// Is everything working at this site?

import { api } from '../../api.ts';
import { ago, day, phones, tabletOnline } from '../../format.ts';
import type { HealthView, SiteView } from '../../types.ts';
import { Loading, Problem, useLoad } from '../../ui.tsx';

export function Health({ site }: { site: SiteView }) {
  const { data: h, error, loading } = useLoad(() => api<HealthView>('GET', `/sites/${site.siteId}/health`), [site.siteId]);
  const online = h ? tabletOnline(h.tabletLastSeen) : false;
  const trouble = h ? h.failed24h + h.unregistered24h : 0;
  return (
    <div className="stack" style={{ gap: 16 }}>
      {error && <Problem text={error} />}
      {loading && !h && <Loading />}
      {h && (
        <>
          <div className="grid4">
            <div className="card">
              <span className="card-label">Ops tablet</span>
              <span className={online ? 'card-value green' : 'card-value amber'}>{h.tablets.length === 0 ? 'Not added' : online ? 'Online' : 'Not online'}</span>
              <span className="muted small">{h.tabletLastSeen ? `Last seen ${ago(h.tabletLastSeen)}` : 'Not seen yet'}</span>
            </div>
            <div className="card">
              <span className="card-label">Phones joined</span>
              <span className="card-value">{phones(h.phonesIos, h.phonesAndroid)}</span>
              <span className="muted small">Counted, never named</span>
            </div>
            <div className="card">
              <span className="card-label">Monthly test</span>
              <span className="card-value">{h.lastTest ? day(h.lastTest) : 'Not sent yet'}</span>
              <span className="muted small">Sent from the ops tablet</span>
            </div>
            <div className="card">
              <span className="card-label">Delivery, last 24 hours</span>
              <span className={trouble ? 'card-value amber' : 'card-value green'}>{trouble ? `${trouble} not reached` : h.accepted24h ? 'All accepted' : 'Nothing sent'}</span>
              <span className="muted small">{h.accepted24h} accepted by Apple and Google</span>
            </div>
          </div>
          <div className="note amber">Critical Alerts are waiting for Apple's approval. Until then, iPhones on silent won't sound.</div>
          {site.readiness.warnings.map((w) => (
            <div key={w} className="note amber">
              {w}
            </div>
          ))}
        </>
      )}
    </div>
  );
}
